import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import FeesBreakdownDetailsIcon from './fees-breakdown-details';
import PaymentSchedule from '../../../containers/member-payments-schedule-link.container';
import money, { format } from '../../../lib/money';
import getCardTypeName from '../../../lib/card-type-names';
import { Time, TIME_FORMAT_SHORT } from '../../../../components/Time';
import Purchase from '../../../lib/purchase';
import { SHARED_NAMESPACE } from '../../../actions';

class YourExpectedChargeDetailed extends Component {
  constructor(props) {
    super(props);
    this.onCommit = this.onCommit.bind(this);
  }

  onCommit(ev) {
    ev.preventDefault();
    this.props.onCommit();
  }

  get allowedAmount() { return money(this.props.allowedAmount); }

  get amount() { return money(this.props.amount); }

  renderFeesBreakdownDetails() {
    const { feesAmount, shareAmount, costPerSlot, claimedSlots, amount } = this.props;

    return (
      <FeesBreakdownDetailsIcon
        claimedSlots={claimedSlots}
        amount={amount}
        shareAmount={shareAmount}
        costPerSlot={costPerSlot}
        feesAmount={feesAmount}
      />
    );
  }

  renderChangeDropdown() {
    if (this.props.waitingToComplete || this.props.anyPaymentsAuthorizing) return;

    return (
      <div className="btn-group change-payment">
        <a
          href="#change"
          className="dropdown-toggle dropdown-toggle-split change-payment-link"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <FormattedMessage
            id="yourExpectedCharge.changeDropdown.change"
            defaultMessage="Change"
          />
        </a>
        <div className="dropdown-menu">
          <a className="dropdown-item px-2" href="#edit" onClick={this.onCommit}>
            <FormattedMessage
              id="yourExpectedCharge.changeDropdown.edit"
              defaultMessage="Edit"
            />
          </a>
          {this.renderWithdrawOption()}
        </div>
      </div>
    );
  }

  renderPaymentSchedule() {
    return (
      <div className="d-inline-block ml-3">
        <PaymentSchedule namespace={SHARED_NAMESPACE} />
      </div>
    );
  }

  totalCostTypeSubtext() {
    const { chargeDate, paymentSource, isMultiPayment } = this.props;
    const date = (<Time format={TIME_FORMAT_SHORT} time={chargeDate} />);

    return (
      <span>
        <FormattedMessage
          id="yourExpectedCharge.expectedChargeDetail.maxCharge"
          defaultMessage="Up to a max. of {allowedAmount}"
          values={{ allowedAmount: format(this.allowedAmount) }}
        />,
        {' '}
        {chargeDate ? (
          <FormattedMessage
            id="yourExpectedCharge.expectedChargeDetail.chargeDate"
            defaultMessage="on or before {date}"
            values={{ date }}
          />
        ) : ''}
        {isMultiPayment ? (
          <span>
            {' '}
            <FormattedMessage
              id="yourExpectedCharge.expectedChargeDetail.acrossAllPayments"
              defaultMessage="across all payments"
            />
            {' '}
          </span>
        ) : ''}
        {' '}
        <FormattedMessage
          id="yourExpectedCharge.expectedChargeDetail.chargeCard.type"
          defaultMessage="to your {cardType}"
          values={{ cardType: getCardTypeName(paymentSource.info.cardType) }}
        />
        {' '}
        <FormattedMessage
          id="yourExpectedCharge.expectedChargeDetail.chargeCard.endingNumbers"
          defaultMessage="ending in {lastFour}"
          values={{ lastFour: paymentSource.info.lastFour }}
        />
      </span>
    );
  }

  perSlotCostTypeSubtext() {
    const { costRange, costPerSlot } = this.props;
    const minCost = money(costRange[0].amount);
    const maxCost = costRange[1] ? money(costRange[1].amount) : minCost;
    let label = (
      <FormattedMessage
        id="yourExpectedCharge.label.totalAndEach"
        defaultMessage="total ({costPerSlot} each)"
        values={{ costPerSlot: format(costPerSlot) }}
      />
    );

    if (maxCost.isGreaterThan(minCost)) {
      label = (
        <FormattedMessage
          id="yourExpectedCharge.label.totalOrLessEach"
          defaultMessage="total ({costPerSlot} or less each)"
          values={{ costPerSlot: format(costPerSlot) }}
        />
      );
    }

    return label;
  }

  renderDetailedExpectedChargeCaption() {
    const { splitType } = this.props;
    const isFixedPerPerson = Purchase.isFixedPerPerson(splitType);
    let label = this.totalCostTypeSubtext();

    if (isFixedPerPerson) {
      label = this.perSlotCostTypeSubtext();
    }

    return (
      <span className="card-icons">
        {label}

        <br />

        {this.renderChangeDropdown()}
        {this.renderPaymentSchedule()}
      </span>
    );
  }

  renderWithdrawOption() {
    return (
      <div>
        <hr className="py-0 my-0" />
        <a className="dropdown-item px-2" href="#withdraw" onClick={this.props.onWithdraw}>
          <FormattedMessage
            id="yourExpectedCharge.withdrawOption"
            defaultMessage="Withdraw"
          />
        </a>
      </div>
    );
  }

  get label() {
    const { isMultiPayment } = this.props;

    if (isMultiPayment) {
      return (
        <FormattedMessage
          id="yourExpectedCharge.label.yourExpectedTotalCharges"
          defaultMessage="Your expected total charges"
        />
      );
    }

    return (
      <FormattedMessage
        id="yourExpectedCharge.label.yourExpectedCharge"
        defaultMessage="Your expected charge"
      />
    );
  }

  render() {
    return (
      <div className="your-expected-charge-detailed">
        <div>
          {this.label} {this.renderFeesBreakdownDetails()}
        </div>
        <h2>{format(this.amount)}</h2>
        <div className="mb-2 small-print card-icons">
          {this.renderDetailedExpectedChargeCaption()}
        </div>
      </div>
    );
  }
}

YourExpectedChargeDetailed.defaultProps = {
  cardName: 'Visa',
  cardLastFour: '0000',
  chargeDate: null,
};

export default YourExpectedChargeDetailed;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/group-summary/your-expected-charge.js